import { render } from "./AdminAddProduct.vue?vue&type=template&id=57f9009f"
import script from "./AdminAddProduct.vue?vue&type=script&lang=js"
export * from "./AdminAddProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__